import { SearchOptions } from '@algolia/client-search';
import { Facet } from './facet';

export interface AlgoliaFilters {
  facetFilters: string[] | string[][];
  numericFilters: string[];
}

export interface UpdateRefinementsParams {
  refinements: Refinements;
  facet: Facet;
  facetValue?: FacetFilterValue;
  numericValue?: NumericFilterValue;
}

export type RefineFunction = (e: Event | React.MouseEvent | React.TouchEvent) => void;

export interface FilterBase {
  seoName: Facet['seoName'];
  relation: Facet['relation'];
}

export interface FacetFilterValue {
  isHero: boolean;
  name: string;
  seoName: string;
  featureValue: string;
}

export interface FacetFilter extends FilterBase {
  values: FacetFilterValue[];
}

export interface NumericFilterValue {
  min: number;
  max: number;
}

export interface NumericFilter extends FilterBase {
  unit: string;
  value: NumericFilterValue;
}

export enum RefinementType {
  FACET_FILTERS = 'facetFilters',
  NUMERIC_FILTERS = 'numericFilters',
  PAGE = 'page',
  QUERY = 'query',
  PRICE_SORT = 'priceSort',
  LOCAL_SEARCH = 'local',
}

export const SEARCH_QUERY_KEY = 'query';
export const PAGE_QUERY_KEY = 'p';
export const PRICE_SORT_QUERY_KEY = 'ps';
export const LOCAL_SEARCH_QUERY_KEY = 'local';

export enum PriceSortQueryValue {
  NONE = 'none',
  ASC = 'asc',
  DESC = 'desc',
}

export interface Refinements {
  [RefinementType.FACET_FILTERS]: {
    [key: string]: FacetFilter;
  };
  [RefinementType.NUMERIC_FILTERS]: {
    [key: string]: NumericFilter;
  };
  [RefinementType.PAGE]: number;
  [RefinementType.QUERY]: string;
  [RefinementType.PRICE_SORT]: PriceSortQueryValue;
  [RefinementType.LOCAL_SEARCH]: string | boolean;
}

export interface SearchStateAlgoliaFilters {
  numericFilters: SearchOptions['numericFilters'];
  facetFilters: SearchOptions['facetFilters'];
}

export interface RefinementItem {
  label: string;
  remove: RefineFunction;
}

export interface RefinementItemsList {
  [key: string]: RefinementItem[];
}

export interface UrlSearchStateValue {
  value: string;
  isHero: boolean;
}

// TODO: fix typings here. it was `[key: string]: UrlSearchStateValue[]` before.
// But that's not working for `query` and other fields
export interface UrlSearchState {
  [key: string]: any;
}
